import { Pagination } from '../store-interfaces';

export type Phrase = {
  id?: number;
  phrase: string;
  sortOrder: number;
  boosted?: boolean;
};

type BotResponse = {
  id: number;
  pageId: number;
  responseText: string;
  sortOrder: number;
};

const triggerKinds = [
  'instagram_keywords',
  'facebook_keywords',
  'webchat_keywords',
  'sms_keywords',
  'welcome_page',
  'default',
];

export type TriggerKind =
  | 'instagram_keywords'
  | 'facebook_keywords'
  | 'webchat_keywords'
  | 'welcome_page'
  | 'sms_keywords'
  | 'default'
  | undefined;

export type TriggerEventType = 'conversation_start' | 'session_start' | '';

export const getTriggerTitleByKind = (kind: TriggerKind) => {
  switch (kind) {
    case 'sms_keywords':
      return 'SMS Keyword';
    case 'facebook_keywords':
      return 'Facebook Keywords';
    case 'instagram_keywords':
      return 'Instagram Keywords';
    case 'webchat_keywords':
      return 'Webchat Keywords';
    default:
      return 'Q&A';
  }
};

export const getTriggerChannelByKind = (kind: TriggerKind) => {
  switch (kind) {
    case 'sms_keywords':
      return 'sms';
    case 'facebook_keywords':
      return 'facebook';
    case 'instagram_keywords':
      return 'instagram';
    case 'webchat_keywords':
      return 'webchat';
    default:
      return 'facebook';
  }
};
export default interface TriggerModel {
  id: number;
  botId: number;
  randomize: boolean;
  sortOrder: number;
  active: boolean;
  phrases: Phrase[];
  botResponses: BotResponse[];
  updatedAt?: string;
  kind: TriggerKind;
  pagination?: Pagination;
  firedCount?: number;
  eventType?: TriggerEventType;
}

export const isTrigger = (v: any): v is TriggerModel => {
  return v?.id && triggerKinds.includes(v.kind);
};
